import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import StArrowRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/st-arrow-right.svg';
import { slugify } from '@utils/studioUtils';
import { FaqOverviewBlockStyles } from './FaqOverviewBlock.styled';

const FaqOverviewBlock = ({ category }) => {
  return (
    <FaqOverviewBlockStyles>
      <h2 className="section-header">{category.sectionHeader}</h2>
      <div className="section-intro">
        <p>{category.sectionIntro}</p>
      </div>
      <ul className="faq-questions">
        {category.faqs?.slice(0, 2).map((faq, j) => {
          const { link } = category.categoryPageLink;
          const lastChar = link.charAt(link.length - 1);
          const categorySlug = lastChar === '/' ? link.slice(0, -1) : link;

          return (
            <li
              key={`faq-${slugify(category.sectionHeader)}-${j + 1}`}
              className="faq-question-link"
            >
              <Link href={`${categorySlug}${faq.slug}`}>
                <div className="faq-question-text">{faq.faqQuestion}</div>{' '}
                <div>
                  <div>
                    <StArrowRightSvg />
                  </div>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
      <p className="faq-category-link">
        <Link href={category.categoryPageLink?.link}>
          {/* note may need a <span></span> */}
          View All <StArrowRightSvg />
        </Link>
      </p>
    </FaqOverviewBlockStyles>
  );
};

export default FaqOverviewBlock;

FaqOverviewBlock.propTypes = {
  category: PropTypes.shape({
    categoryPageLink: PropTypes.shape({
      link: PropTypes.string,
    }),
    faqs: PropTypes.arrayOf(
      PropTypes.shape({
        faqQuestion: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
    sectionHeader: PropTypes.string,
    sectionIntro: PropTypes.string,
  }),
};
